import { Award, Download } from "lucide-react";
import { toast } from "sonner";
import { downloadFile } from "@/lib/api";
import { usDate } from "./ui";

const slug = (s) => (s || "staff").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
export const downloadCert = (topic, userId, name) =>
  downloadFile(`/training/certificate/${topic}${userId ? `?user_id=${userId}` : ""}`, `${topic}-certificate-${slug(name)}.pdf`)
    .catch(() => toast.error("Certificate download failed"));

export function CertBadge({ badge, date, large = false, testid, onDownload }) {
  const cls = `inline-flex items-center gap-1 font-bold uppercase tracking-widest text-[#5B21B6] bg-[#EDE9FE] border border-[#C4B5FD] ${large ? "text-sm px-4 py-2" : "text-[9px] px-1.5 py-0.5"}`;
  const body = <><Award size={large ? 18 : 10} /> {badge}{onDownload && <Download size={9} className="ml-0.5 opacity-70" />}</>;
  const title = `${date ? `Certified ${usDate(date)}` : ""}${onDownload ? " · click to download certificate" : ""}`;
  return onDownload
    ? <button type="button" onClick={onDownload} className={`${cls} hover:bg-[#DDD6FE] transition-colors`} title={title} data-testid={testid}>{body}</button>
    : <span className={cls} title={title || undefined} data-testid={testid}>{body}</span>;
}

export default function CertBadges({ certs = [], userId, downloadFor, name }) {
  if (!certs.length) return null;
  return (
    <div className="flex flex-wrap gap-1 mt-1" data-testid={`user-cert-badges-${userId}`}>
      {certs.map((c) => (
        <CertBadge key={c.topic} badge={c.badge} date={c.certified_at} testid={`user-cert-${userId}-${c.topic}`}
          onDownload={downloadFor ? () => downloadCert(c.topic, downloadFor, name) : undefined} />
      ))}
    </div>
  );
}
